import { gql } from '@apollo/client';

export const fetchPaymentMethodsForTransactionAccountOnTab = gql`
  query fetchPaymentMethodsForTransactionAccountOnTab($id: ID!, $viewSubscriptionsLink: Boolean) {
    transactionAccount(id: $id) {
      id
      updatePaymentMethodLink
      availableInvoiceGroups {
        nodes {
          id
          defaultPaymentMethod {
            id
            type
            paymentIssue
          }
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
          }
        }
      }
      availablePaymentMethods(viewSubscriptionsLink: $viewSubscriptionsLink) {
        totalCount
        nodes {
          id
          paymentIssue
          type
          default
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
              cardHolderName
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
            totalCreditLimit
            paymentMethod
          }
          hasLinkedSubscriptions
        }
      }
      customerBalances {
        usd
      }
    }
  }
`;
